import { useCallback, useContext, useEffect, useState } from "react";

import { ApiHelper } from "@datanac/datanac-api-toolkit/dist/api-helper";
import { _sessionManager } from "api/ApiHelper";
import { AppContext } from "App";

export default function useDebtSchedules({ year }) {
  const { globalState } = useContext(AppContext);
  const [debtSchedules, setDebtSchedules] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDebtSchedules = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const api = new ApiHelper({
        baseUrl: import.meta.env.VITE_DATANAC_USERS_API_URL_BASE,
        config: {},
        sessionManager: _sessionManager,
        _instance: null,
      });

      const filter = {
        producer_token: globalState?.producer_token,
        year: year,
        is_active: true,
      };

      const result = await api.callPost("debtSchedule/Search", filter, globalState);
      setDebtSchedules(result || []);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, [globalState?.producer_token, year]);

  useEffect(() => {
    if (globalState?.producer_token) {
      fetchDebtSchedules();
    }
  }, [globalState?.producer_token, fetchDebtSchedules, year]);

  const create = useCallback(
    async (debt) => {
      setIsLoading(true);
      setError(null);
      try {
        const api = new ApiHelper({
          baseUrl: import.meta.env.VITE_DATANAC_USERS_API_URL_BASE,
          config: {},
          sessionManager: _sessionManager,
          _instance: null,
        });
        await api.callPost(
          "debtSchedule",
          {
            DebtSchedule: [debt],
            document_id: debt.document_id,
            producer_token: globalState.producer_token,
          },
          globalState
        );
        await fetchDebtSchedules();
      } catch (err) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    },
    [globalState, fetchDebtSchedules]
  );

  const update = useCallback(
    async (debt) => {
      setIsLoading(true);
      setError(null);
      try {
        const api = new ApiHelper({
          baseUrl: import.meta.env.VITE_DATANAC_USERS_API_URL_BASE,
          config: {},
          sessionManager: _sessionManager,
          _instance: null,
        });
        await api.callPost(
          "debtSchedule",
          {
            DebtSchedule: [debt],
            document_id: debt.document_id,
            producer_token: globalState.producer_token,
          },
          globalState
        );
        await fetchDebtSchedules();
      } catch (err) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    },
    [globalState, fetchDebtSchedules]
  );

  const remove = useCallback(
    async (debt) => {
      setIsLoading(true);
      setError(null);
      try {
        const api = new ApiHelper({
          baseUrl: import.meta.env.VITE_DATANAC_USERS_API_URL_BASE,
          config: {},
          sessionManager: _sessionManager,
          _instance: null,
        });
        await api.callPost(
          "debtSchedule",
          {
            DebtSchedule: [{ ...debt, is_active: false }],
            document_id: debt.document_id,
            producer_token: globalState.producer_token,
          },
          globalState
        );
        await fetchDebtSchedules();
      } catch (err) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    },
    [globalState, fetchDebtSchedules]
  );

  return { debtSchedules, isLoading, error, create, update, remove };
}
